import type { TypographyVariantsOptions } from "@mui/material";
import { FONT_WEIGHTS } from "./Constants";

export const TYPOGRAPHY_OVERRIDES: TypographyVariantsOptions = {
  htmlFontSize: 16,
  fontSize: 14,
  fontFamily: '"Open Sans", sans-serif',
  fontWeightLight: FONT_WEIGHTS.LIGHT,
  fontWeightRegular: FONT_WEIGHTS.REGULAR,
  fontWeightMedium: FONT_WEIGHTS.MEDIUM,
  fontWeightSemiBold: FONT_WEIGHTS.SEMI_BOLD,
  fontWeightBold: FONT_WEIGHTS.BOLD,

  h1: {
    fontSize: "3rem",
    fontWeight: FONT_WEIGHTS.LIGHT,
  },
  h2: {
    fontSize: "2rem",
    fontWeight: FONT_WEIGHTS.LIGHT,
  },
  h3: {
    fontSize: "1.5rem",
    fontWeight: FONT_WEIGHTS.REGULAR,
  },
  h4: {
    fontSize: "1.25rem",
    fontWeight: FONT_WEIGHTS.SEMI_BOLD,
  },
  h5: {
    fontSize: "1.125rem",
    fontWeight: FONT_WEIGHTS.SEMI_BOLD,
  },
  h6: {
    fontSize: "1rem",
    fontWeight: FONT_WEIGHTS.MEDIUM,
  },

  subtitle1: {
    fontSize: "1rem",
    fontWeight: FONT_WEIGHTS.REGULAR,
  },
  subtitle2: {
    fontSize: "0.875rem",
    fontWeight: FONT_WEIGHTS.REGULAR,
  },
  body1: {
    fontSize: "0.875rem",
    fontWeight: FONT_WEIGHTS.REGULAR,
  },
  body2: {
    fontSize: "0.75rem",
    fontWeight: FONT_WEIGHTS.REGULAR,
  },
  button: {
    fontWeight: FONT_WEIGHTS.REGULAR,
    textTransform: "none",
  },
  caption: {
    fontSize: "0.75rem",
    fontWeight: FONT_WEIGHTS.REGULAR,
  },
  overline: {
    fontSize: "0.75rem",
    textTransform: "none",
  },
};
